import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FileExcelFilledSvg from "@ant-design/icons-svg/es/asn/FileExcelFilled";
import AntdIcon from "../components/AntdIcon";
var FileExcelFilled = function FileExcelFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileExcelFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FileExcelFilled.displayName = 'FileExcelFilled';
}
export default /*#__PURE__*/React.forwardRef(FileExcelFilled);